import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalDeleteComment: ExperimentalMutations['experimentalDeleteComment'] = (
	_,
	{ contentId },
	{ network: { cfetch } },
) =>
	cfetch(`/wiki/rest/api/content/${contentId}/?status=current`, {
		method: 'DELETE',
		headers: {
			Accept: MediaType.JSON,
			'Content-Type': MediaType.JSON,
		},
	}).then((response) => ({
		contentId,
		// TODO FIXME experimental schema actually specifies this as String, so either schema needs to be fixed, or the code
		statusCode: response.status as any as string,
	}));
